import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Box, Container, Grid, Typography, Button } from "@mui/material";
import { IconArrowRight } from "@tabler/icons-react";
import { useUsuario } from "../../../providers/usuarioProvider";
import RenderAnimation from "../../util/ui/renderAnimation";
import Atualizar from "../home/atualizar";
import { onSnapshot } from "firebase/firestore";
import UsuarioDb from "../../../db/usuarioDb";
import { Link } from "react-router-dom";
import Usuario from "../../../models/usuario";
import { Perfil } from "../../../models/enum";

const PREFIX = "nenhumMes";

const classes = {
  container: `${PREFIX}-container`,
  cardSpacing: `${PREFIX}-cardSpacing`,
  botaoAcao: `${PREFIX}-botaoAcao`,
};

const StyledContainer = styled(Container)(({ theme }) => ({
  [`&.${classes.container}`]: { padding: theme.spacing(6, 3) },
  [`& .${classes.cardSpacing}`]: { padding: theme.spacing(1) },
  [`& .${classes.botaoAcao}`]: { margin: theme.spacing(3, 0, 0) },
}));

export default function NenhumMes() {
  const { visualizado, claims } = useUsuario();
  const [usuario, setUsuario] = useState<Usuario>();
  // Quem lê é o contador, não o investidor: o texto fala do cliente.
  const leitorContador = claims?.perfil === Perfil.CONTADOR;

  useEffect(() => {
    if (visualizado) {
      return onSnapshot(
        new UsuarioDb().doc({ usuarioId: visualizado }),
        (snapshot) => {
          setUsuario(snapshot.data());
        }
      );
    }
  }, [visualizado]);

  return (
    <StyledContainer maxWidth="md" className={classes.container}>
      <Grid container alignItems="flex-start">
        <Grid item xs={12} className={classes.cardSpacing}>
          {(usuario?.estatisticas?.notas ?? 0) > 0 ? (
            <RenderAnimation
              key="h5"
              delay={1 * 300}
              render={() => <Atualizar />}
            />
          ) : (
            <>
              <RenderAnimation
                key="h5"
                delay={0 * 300}
                render={() => (
                  <Box>
                    <Typography
                      variant="eyebrow"
                      color="text.secondary"
                      gutterBottom
                    >
                      Timeline
                    </Typography>
                    {/* Estado vazio grande: display + palavra em itálico accent. */}
                    <Typography variant="display" color="text.primary">
                      {leitorContador
                        ? "Este cliente ainda não tem "
                        : "Você ainda não cadastrou as suas "}
                      <Box
                        component="em"
                        sx={(theme) => ({
                          fontStyle: "italic",
                          color: theme.palette.accentInk,
                        })}
                      >
                        notas
                      </Box>
                      {leitorContador ? " cadastradas." : "."}
                    </Typography>
                  </Box>
                )}
              />
              <RenderAnimation
                key="subtitle1"
                delay={1 * 300}
                render={() => (
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ maxWidth: "56ch", mt: 2 }}
                  >
                    {leitorContador
                      ? "Para iniciar a apuração, importe as notas de corretagem ou o extrato da B3 do cliente."
                      : "Para iniciar seus cálculos, cadastre todas as suas notas antes."}
                  </Typography>
                )}
              />
              <RenderAnimation
                key="button"
                delay={2 * 300}
                render={() => (
                  <Button
                    className={classes.botaoAcao}
                    variant="contained"
                    color="primary"
                    component={Link}
                    to="/arquivo"
                    endIcon={<IconArrowRight size={16} />}
                  >
                    Cadastrar notas
                  </Button>
                )}
              />
            </>
          )}
        </Grid>
      </Grid>
    </StyledContainer>
  );
}
